import { Component } from "nuxt-property-decorator";
import ResponseHandler from "~/helpers/validations/ResponseHandler";
import { Validations } from "vuelidate-property-decorators";
import {
  required,
  email,
  sameAs, // @ts-ignore
} from "vuelidate/lib/validators";

@Component({})
export default class ContactValidator extends ResponseHandler {
  @Validations()
  validations = {
    form: {
      nome: { required },
      cognome: { required },
      telefono: { required },
      note: { required },
      email: { required, email },
      accettazione_privacy: {
        sameAs: sameAs(() => true),
      },
    },
  };
}
